// extracted by mini-css-extract-plugin
module.exports = {"flag":"flag_flag__gCV2s","name":"flag_name___16PM","tags":"flag_tags__I2MqB","tag":"flag_tag__nC1Ev","override":"flag_override__cUl_5","ab":"flag_ab__bpsnu"};